import { render, staticRenderFns } from "./StatusColumn.vue?vue&type=template&id=2a1078d8"
import script from "./StatusColumn.vue?vue&type=script&lang=js"
export * from "./StatusColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports